import { Schema, arrayOf } from 'normalizr';

export const caseSite = new Schema('caseSites');
export const arrayOfCaseSites = arrayOf(caseSite);



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases/api/schema.js